import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';

import { setInStorage, removeFromStorage } from '../features/storageSlice';
// import { getOperationKey } from './util';

interface IndexByAny {
  [key: string]: any,
};

export function useTypedStorage<T>(storageName:string, defaultValue:T|null = null) {
  const [storageObj, _updateStorage, deleteObjFromStorage] = useStorage(storageName, defaultValue);
  const storageObjRef = useRef<T|null>(null);

  useEffect(() => {
    storageObjRef.current = storageObj;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageObj]);

  const updateStorage = (value:Partial<T>) => {
    _updateStorage(value);
  };

  return [storageObj as T|any, updateStorage, deleteObjFromStorage, storageObjRef];
}

export default function useStorage(storageName:string, defaultValue:any = null) {
  const storageObj = useAppSelector(x => x.storage[storageName]);
  const dispatch = useAppDispatch();
  const storageObjRef = useRef<any|null>(null);

  useEffect(() => {
    storageObjRef.current = storageObj;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageObj]);

  const updateStorage = (value:any) => {
    const obj: IndexByAny = {};
    obj[storageName] = value;

    dispatch(setInStorage(obj));
  };

  const deleteObjFromStorage = () => {
    dispatch(removeFromStorage(storageName));
  };

  return [storageObj === null || storageObj === undefined ? defaultValue : storageObj, updateStorage, deleteObjFromStorage, storageObjRef];
}
  